import { get, post, put, del, buildUrl } from './apiClient';
import type { IFlowButton, IFlowButtonCreateRequest, IFlowButtonUpdateRequest } from '@/types/flowbutton';

const BASE_URL = '/api/v1/flow-buttons';

export interface FlowButtonListFilter {
  page?: string;
  [key: string]: unknown;
}

export const flowButtonService = {
  list: (filter?: FlowButtonListFilter): Promise<IFlowButton[]> =>
    get<IFlowButton[]>(buildUrl(BASE_URL, filter)),

  get: (id: string): Promise<IFlowButton> =>
    get<IFlowButton>(`${BASE_URL}/${id}`),

  create: (data: IFlowButtonCreateRequest): Promise<IFlowButton> =>
    post<IFlowButton>(BASE_URL, data),

  update: (id: string, data: IFlowButtonUpdateRequest): Promise<IFlowButton> =>
    put<IFlowButton>(`${BASE_URL}/${id}`, data),

  delete: (id: string): Promise<void> =>
    del(`${BASE_URL}/${id}`),
};
